module.exports = __webpack_public_path__ + "img/zhongjishuimian_jpg_smzlpg.ef6d1f71.png";